import { TableColumn } from "react-data-table-component";
import {
    ActionTypeEnum,
    GridColumnsHookParamsModel,
    TableActionColumnsStyleEnum,
    RequestActionModel,
    GridColumnsResponseModel
} from  "../../../../../models";
import {ServerDropdownActions} from "../rendering/renderGridActionsColumns";

interface GenerateGridColumnsParams<T> extends GridColumnsHookParamsModel<T> {
    data: any[];
    formId?: number | null;
    style?: TableActionColumnsStyleEnum | null;
    getRowActions?: (row: any,rowIndex:number) => ActionTypeEnum[];
}

export async function generateGridColumnsWithActions<T>({
                                                            actions = [],
                                                            formId,
                                                            isArabic,
                                                            onActionEvent,
                                                            actionsColumnGrow,
                                                            data,
                                                            style,
                                                            getRowActions,
                                                        }: GenerateGridColumnsParams<T>): Promise<{
    settingsColumns: GridColumnsResponseModel[];
    gridCols: TableColumn<T>[];
}> {
    const settingsColumns: GridColumnsResponseModel[] = [];
    let gridCols: TableColumn<T>[] = [];

    // Only add an Actions column if we have actions or a row-specific action resolver
    if (actions.length > 0 || getRowActions) {
        const actionColumn = {
            id: "Actions",
            name: "", // Empty name for the column header
            selector: (row: any) => row,
            right: !isArabic,
            grow: 1,
            width: "auto", // Fixed width for the actions column
            sortable: false,
            reorder: false,
            center: true, // Center the content
            compact: true,
            ignoreRowClick: true, // Prevent row click events in this column
            button: true, // Mark as a button column
            cell: (row: any, rowIndex: number) => {
                // Get both static and dynamic actions for this row
                const rowSpecificActions = getRowActions ? getRowActions(row, rowIndex) : [];

                // Combine and de-duplicate actions
                const allActions = [...actions, ...rowSpecificActions];
                const combinedActions = allActions.filter((action, index) =>
                    allActions.indexOf(action) === index);

                const isIconRender: boolean =
                    //style === TableActionColumnsStyleEnum.Dropdown ||
                    style === TableActionColumnsStyleEnum.DropdownIcon;
                const isTextRender: boolean =
                    style === TableActionColumnsStyleEnum.Dropdown ||
                    style === TableActionColumnsStyleEnum.DropDownText;

                // Return the ServerDropdownActions component with the combined actions
                return (
                    <ServerDropdownActions
                        actionsPermitted={combinedActions}
                        formId={formId || 0}
                        onActionEvent={onActionEvent || (() => {})}
                        row={row}
                        isIconRender={isIconRender}
                        isTextRender={isTextRender}
                    />
                );
            },
        };

        gridCols.push(actionColumn);
    }

    return {
        settingsColumns,
        gridCols,
    };
}